import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    transform: scale(1);
  }

  55% {
    background-color: #3A1D93;
    transform: scale(1.6);
  }
`;

const Beacon = styled.span`
	animation: ${pulse} 1s ease-in-out infinite;
	background-color: '#3A1D93';
	border-radius: 50%;
	display: inline-block;
	height: 1.5rem;
	width: 1.5rem;
	cursor: default;
`;

export default Beacon;
